import { useAuthStore } from '../../../stores/authStore';
import { admin, typography } from '../../../styles/tokens';

export default function WelcomeBlock() {
  const firstName = useAuthStore(s => s.user?.first_name);
  const businessName = useAuthStore(s => s.business?.name);

  const greeting = firstName ? `Welcome, ${firstName}.` : 'Welcome.';
  const bizPhrase = businessName ? `run ${businessName} through CrewBit` : 'run your business through CrewBit';

  return (
    <div style={{ marginBottom: 32 }}>
      <div
        style={{
          fontSize: typography.size.hero,
          fontWeight: typography.weight.bold,
          color: admin.header,
          letterSpacing: '-0.02em',
          lineHeight: typography.lineHeight.tight,
          marginBottom: 12,
        }}
      >
        {greeting}
      </div>
      <div
        style={{
          fontSize: typography.size.title,
          fontWeight: typography.weight.semibold,
          color: admin.header,
          letterSpacing: '-0.01em',
          lineHeight: typography.lineHeight.tight,
          marginBottom: 16,
        }}
      >
        Let's get your business ready.
      </div>
      <div
        style={{
          fontSize: typography.size.body,
          color: admin.body,
          lineHeight: typography.lineHeight.relaxed,
          maxWidth: 640,
        }}
      >
        We'll walk you through a few quick things, and you'll be all set up to {bizPhrase}. Most
        people finish in 10–20 minutes. You can save your progress and come back anytime.
      </div>
    </div>
  );
}
